import { authApi } from "@config/axios/axios.config";
import { API_ROUTES } from "@constants/api.routes";
import { extractAttachmentUrl } from "@utils/attachmentResponse";

/**
 * Fetch a presigned attachment URL by object key.
 */
export const fetchAttachmentByKey = async (key: string): Promise<string> => {
	try {
		const response = await authApi.get(API_ROUTES.ATTACHMENT_BY_KEY(key));
		return extractAttachmentUrl(response);
	} catch (error) {
		console.error(`Error fetching attachment for key ${key}:`, error);
		throw error;
	}
};
